import { Component, Input, OnInit } from '@angular/core';
import Tile from 'ol/layer/tile';

@Component({
  selector: 'app-overlay-layer-select',
  templateUrl: './overlay-layer-select.component.html',
  styleUrls: ['./overlay-layer-select.component.scss']
})
export class OverlayLayerSelectComponent implements OnInit {
  @Input()
  item: Tile;

  constructor() {}

  ngOnInit() {}

  onChange($event: CustomEvent): void {
    this.item.setVisible($event.detail.checked);
  }
}
